import {
  isUserWithRoles, useCombinedUser, useIsAuth, useIsMsalAuth, UserRoles,
} from '@equifinance/shared';
import { IgnoredByType } from '../../../contexts/credit';

export default function useIgnoreByType(): IgnoredByType | null {
  const isInternalUser = useIsMsalAuth();
  const { user } = useCombinedUser();
  const isBroker = useIsAuth();
  const isUnderwriter = isInternalUser && isUserWithRoles([UserRoles.UNDERWRITER], user);
  const isSalesSupport = isInternalUser && isUserWithRoles([UserRoles.SALES_SUPPORT], user);

  if (isUnderwriter) return IgnoredByType.Underwriter;
  if (isSalesSupport) return IgnoredByType.SalesSupport;
  if (isBroker) return IgnoredByType.Broker;

  return null;
}
